import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiInteractiveQuoteForm' })(
  ({ brandType, brandColors, breakpoints, type, typography, spacing }) => ({
    container: {
      minHeight: '100vh',
      display: 'flex',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        flexDirection: 'column-reverse',
        justifyContent: 'flex-end',
      },
    },
    leftHalfContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      minHeight: '100vh',
      width: '50%',
      [breakpoints.down(ScreenSize.LARGE)]: {
        width: '100%',
        minHeight: 'auto',
        height: 'auto',
        flex: 1,
      },
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      paddingLeft: typography.pxToRem(80),
      paddingRight: typography.pxToRem(60),
      height: typography.pxToRem(490),
      justifyContent: 'center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        height: 'auto',
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(24),
        paddingRight: typography.pxToRem(24),
      },
    },
    innerContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: 1,
      maxHeight: typography.pxToRem(600),
      [breakpoints.down(ScreenSize.LARGE)]: {
        justifyContent: 'space-between',
        paddingTop: typography.pxToRem(30),
        paddingBottom: typography.pxToRem(40),
      },
    },
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      [breakpoints.down(ScreenSize.LARGE)]: {
        height: 'auto',
      },
    },
    landingFormContainer: {
      [breakpoints.down(ScreenSize.LARGE)]: {
        justifyContent: 'flex-end!important',
        paddingBottom: 0,
      },
    },
    rightHalfContainer: {
      minHeight: '100vh',
      height: 'auto',
      width: '50%',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      [breakpoints.down(ScreenSize.LARGE)]: {
        height: typography.pxToRem(371),
        width: '100%',
        minHeight: '100%',
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        height: typography.pxToRem(175),
        minHeight: '100%',
      },
    },
    heading: {
      ...type['56_medium'],
      color: brandColors.heroBlue,
      marginBottom: typography.pxToRem(35),
      textWrap: 'pretty',
      [breakpoints.down(ScreenSize.LARGE)]: {
        ...type['56_medium'],
        marginBottom: typography.pxToRem(18),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['44_medium'],
      },
    },
    subheading: {
      color: brandColors.heroBlue,
      fontFamily: 'Roobert',
      fontWeight: 400,
      fontSize: typography.pxToRem(28),
      lineHeight: typography.pxToRem(36),
      letterSpacing: '-0.56px',
      marginBottom: typography.pxToRem(55),
      textWrap: 'pretty',
      [breakpoints.down(ScreenSize.LARGE)]: {
        ...type['24_medium'],
        marginBottom: 20,
      },
    },
    inputClass: {
      width: '100%',
      height: typography.pxToRem(60),
      padding: `${typography.pxToRem(18)} ${typography.pxToRem(16)}`,
      borderRadius: typography.pxToRem(8),
      ...type['16_medium'],
      color: brandColors.heroBlue,
      border: `1px solid ${brandColors.mediumGrey} `,
      '&::placeholder': {
        ...type['16_medium'],
        color: brandColors.tintsNeutral20,
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        width: '100%',
      },
    },
    inputContainer: {
      width: '100%',
      maxWidth: typography.pxToRem(375),
    },
    buttonContainer: {
      paddingTop: typography.pxToRem(16),
    },
    button: {
      width: '100%',
    },
    label: {
      ...type['16_medium'],
      color: brandColors.tintsHeroBlue70,
      marginBottom: typography.pxToRem(4),
    },
    checkboxLabel: {
      fontFamily: 'Roobert',
      fontSize: typography.pxToRem(14),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '120%',
    },
    checkbox: {
      width: typography.pxToRem(24),
      height: typography.pxToRem(24),
      marginRight: '0.5rem',
    },
    logoWrapper: {
      marginLeft: typography.pxToRem(80),
      marginTop: typography.pxToRem(103),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        marginBottom: 0,
        marginLeft: '5%',
        marginTop: '5%',
      },
    },
    logo: {
      color: brandColors.primaryMain,
      marginTop: '5%',
      marginLeft: typography.pxToRem(2),
      marginBottom: 0,
      [breakpoints.up(ScreenSize.LARGE)]: {
        margin: `auto ${typography.pxToRem(15)}`,
      },
    },
    landingLogo: {
      marginBottom: typography.pxToRem(41),
    },
    checkboxContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: typography.pxToRem(20),
    },
    error: {
      marginTop: typography.pxToRem(10),
      height: typography.pxToRem(16),
      color: brandColors.errorMain,
      ...brandType['body-s'],
    },
    confirmationCTA: {
      marginBottom: spacing(2),
    },
  })
);

export default useStyles;
